import React from "react";
import { PaperBG } from "../kits";

export default function Datenschutz() {
  return (
    <PaperBG>
      <div className="pt-10"></div>
    <div className="max-w-3xl mx-auto px-6 py-20 font-mono text-xs text-gray-900 space-y-6">
      <h1 className="text-xl bg-gray-900 text-orange-50 rounded-md font-semibold mb-6 px-1 text-shadow">Datenschutz</h1>

      <section className="px-1">
        <h2 className="text-sm font-semibold mb-2">1. Allgemeines</h2>
        <p>
          Der Schutz deiner Daten ist mir wichtig. Diese Seite informiert dich darüber, wie ich mit personenbezogenen Daten umgehe, wenn du meine Website besuchst, mich kontaktierst oder einen Kurs anfragst.
        </p>
      </section>

      <section className="px-1">
        <h2 className="text-md font-semibold mb-2">2. Verantwortlich</h2>
            <p>
         Denis Bitter
         </p>
  
        
          E-Mail: saghallo@denisbitter.de
      
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">3. Welche Daten werden erfasst</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Name, E-Mail und Nachricht bei Kontaktaufnahme</li>
          <li>Auswahl deines Kurswunsches (z. B. Programm, Kategorie, Freitext)</li>
          <li>Nutzungsdaten (z. B. Browser, Bildschirmgröße, IP-Adresse in anonymisierter Form)</li>
        </ul>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">4. Zweck der Verarbeitung</h2>
        <p>
        Nutzen deine Daten ausschließlich, um:
        </p> <br />
        <ul className="list-disc pl-5 space-y-1">
          <li>deine Anfrage zu beantworten</li>
          <li>dir passende Inhalte vorzuschlagen</li>
          <li>mein Angebot zu verbessern (z. B. welche Interessen gefragt sind)</li>
        </ul>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">5. Drittanbieter</h2>
        <p>
          Ich setze auf Drittanbieter, um bestimmte Funktionen und Inhalte bereitzustellen:
        </p> <br />

        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>YouTube & Vimeo:</strong> Für das Abspielen von eingebetteten Videos. Beim Aufruf kann deine IP-Adresse an die Anbieter übertragen werden.
          </li>
          <li>
            <strong>E-Mail-Dienstleister:</strong> Wenn du dich zu einem Newsletter anmeldest, nutze ich ggf. Anbieter wie Mailchimp oder Sendinblue. Dabei werden deine Kontaktdaten dort gespeichert.
          </li>
        </ul>
        <p> <br />
          Diese Anbieter handeln in unserem Auftrag gemäß Art. 28 DSGVO (Auftragsverarbeitung). Es gelten deren Datenschutzrichtlinien.
        </p>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">6. Hosting</h2>
        <p>
          Meine Website wird bei einem europäischen Hostinganbieter betrieben. Dabei werden technische Daten wie IP-Adresse und Zeitstempel erfasst, um die Seite auszuliefern und abzusichern. Es findet keine Weitergabe dieser Daten an Dritte statt.
        </p>
       <p>
            Aktueller Anbieter: <strong>IONOS SE Elgendorfer Str. 57 56410 Montabaur</strong>
            </p>
            <p>
            Die Datenverarbeitung erfolgt innerhalb der EU. Es besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO.
            </p>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">7. Speicherdauer</h2>
        <p>
         Ich speichere deine Daten nur so lange, wie es für die Bearbeitung deiner Anfrage notwendig ist. Danach werden sie gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
        </p>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">8. Deine Rechte</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Auskunft über gespeicherte Daten</li>
          <li>Berichtigung, Löschung oder Einschränkung</li>
          <li>Widerruf deiner Einwilligung</li>
          <li>Beschwerde bei einer Datenschutzbehörde</li>
        </ul>
      </section>

      <section classname="px-1">
        <h2 className="text-md font-semibold mb-2">9. Kontakt</h2>
        <p>
          Wenn du Fragen zum Datenschutz hast oder wissen möchtest, welche Daten ich über dich gespeichert habe, schreib mir gerne eine E-Mail an: 
        </p>
           <strong><a href="mailto:saghallo@denisbitter.de" className="underline">saghallo@denisbitter.de</a><br /></strong>
      </section>

   <div>      <p className="text-xs bg-gray-900 text-orange-50 text-shadow text-left pl-5">Stand: Mai 2025</p></div>
      
    </div>

     
    </PaperBG>
  );
}
